import { useEffect, useState } from 'react';

export const useEditorAnnotationVisible = (isControlsVisible: boolean) => {
    const [visible, setVisible] = useState<boolean>(isControlsVisible);

    useEffect(() => {
        if (!isControlsVisible) {
            setVisible(false);
        }
    }, [isControlsVisible]);

    return visible;
};
